import type { JSX } from 'react';
import type { CuratorInfo } from '@/services/slaydAPI/posts';
import styles from '../ApprovalPortalPage.module.css';

interface CuratorCardProps {
  curator: CuratorInfo;
  postTypeDisplay: string;
}

export const CuratorCard = ({
  curator,
  postTypeDisplay,
}: CuratorCardProps): JSX.Element => (
  <div className={styles.reviewCuratorInfo}>
    <div className={styles.curatorAvatar}>
      {curator.imageUrl ? (
        <img
          src={curator.imageUrl}
          alt={curator.name}
          className={styles.curatorAvatarImg}
        />
      ) : (
        <div className={styles.curatorAvatarPlaceholder}>
          {curator.name?.[0] || '?'}
        </div>
      )}
    </div>
    <div className={styles.curatorInfo}>
      <div className={styles.curatorName}>{curator.name}</div>
      <div className={styles.curatorHandle}>
        @{curator.igUsername || 'unknown'}
      </div>
    </div>
    <span className={styles.typeBadge}>{postTypeDisplay}</span>
  </div>
);
